import { getPermissions } from '@dispatch/shared/services';
import { useQuery } from '../useQuery';

export const useGetPermissions = () => {
  return useQuery(['permissions'], () => getPermissions(), { staleTime: 5000 });
};
